import {createContext} from 'react'

import {noop} from '../../../../../../../utils/empty'

export type JobGameTabContextValue = {
  wasFound: boolean
  setWasFound: (state: boolean) => void
}

export const JobGameTabContextDefaultValue = {
  wasFound: false,
  setWasFound: noop,
}

export const JobGameTabContextContext = createContext<JobGameTabContextValue>(
  JobGameTabContextDefaultValue,
)
